import { BaseItem } from '@lib/components/Table/types';

export const isItemsMatch = <T extends BaseItem>(a: T, b: T) => {
  if (a.id !== undefined && b.id !== undefined) return a.id === b.id;
  return a === b;
};
